import React, { FC } from 'react';

import { CloseIcon } from '@evinced-private/ui-common';

import { AnnouncementBanner } from 'src/apps/mfa/components/announcement-banner/AnnouncementBanner';
import { useMfaBannerStore } from 'src/apps/mfa/stores/mfaBannerStore';
import { ClarificationBanner } from 'src/common/components/clarification-banner/ClarificationBanner';
import { ProductType } from 'src/common/interfaces/Tenant';
import { DashboardContainer } from 'src/common/pages/dashboards-container/DashboardContainer';

import { MFASessionsPage } from '../sessions/MfaSessionsPage';

import './DashboardContainerMfa.scss';

export const DashboardContainerMfa: FC = () => {
	const { visible: isBannerVisible, setVisible } = useMfaBannerStore();

	return (
		<div className="dashboard-container-mfa">
			{isBannerVisible && (
				<div className="clarification-banner-wrapper">
					<ClarificationBanner
						hide={() => setVisible(false)}
						dismissIcon={CloseIcon}
						showToggle={false}
					>
						<AnnouncementBanner />
					</ClarificationBanner>
				</div>
			)}
			<DashboardContainer product={ProductType.MOBILE_FLOW_ANALYZER}>
				<MFASessionsPage />
			</DashboardContainer>
		</div>
	);
};
